export const SVG_ICON_NAMES = [
  '',
  'ac_unit',
  'admin_panel_settings',
  'android',
  'grid-dots-horizontal-center',
  'app-store',
  'app-google-play',
  'app-play-store',
  'arrow-back',
  'arrow-down',
  'arrow-forward',
  'Home-Icon',
  'arrow-left',
  'arrow-left-wallet',
  'arrow-narrow-left',
  'arrow-narrow-right',
  'arrow-open',
  'arrow-open-external-link',
  'arrow-right',
  'arrow-up',
  'auto_meeting_room',
  'auto_stories',
  'balcony',
  'bar',
  'bathroom',
  'beaker',
  'bed',
  'bell',
  'blender',
  'blocks-dfsa',
  'briefcase',
  'burger',
  'burj_khalifa',
  'business-unit-radio',
  'calculator',
  'calendar',
  'canal_view',
  'cancel',
  'cart',
  'cash',
  'cash-coin',
  'celebration',
  'chart-bar',
  'chat',
  'check-circle',
  'check-circle-filled',
  'checkmark',
  'chevron-down',
  'chevron-down-yellow',
  'chevron_yellow_line',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chevron-up-yellow',
  'chevron-white',
  'circle-spinner',
  'clear',
  'clock',
  'close',
  'code_bracket',
  'collapsing-cubes',
  'copy',
  'copy-05',
  'copy-06',
  'Close_09',
  'csv',
  'cube',
  'cube-blocks',
  'cube-blocks-gradient',
  'cube-colored',
  'cube-gradient',
  'cube-mortgage',
  'cube-outline',
  'curtains',
  'customer',
  'dashboard',
  'dfsa',
  'diversity',
  'domain',
  'download',
  'dropdown-arrow',
  'email',
  'exclamation-circle',
  'excel',
  'exclude',
  'expand',
  'eye',
  'face_4',
  'facebook',
  'Frame-321316212',
  'ferris_wheel',
  'file-copy',
  'filter-list',
  'financial-projection',
  'financial_projection',
  'fitness_center',
  'folder',
  'fractional-ownership',
  'ForPartners',
  'garage_home',
  'glossary',
  'golden-visa',
  'golden-visa-menu',
  'golf_course',
  'google-play',
  'grade',
  'grid',
  'gym',
  'help',
  'help_outlined',
  'help-circle',
  'help-circle-black',
  'high_floor',
  'hold',
  'home',
  'home_health',
  'home_pin',
  'home_work',
  'hot_tub',
  'house',
  'hub',
  'hub-menu',
  'image',
  'image-gallery',
  'virtual-tour',
  'coins-hand',
  'inbox',
  'info',
  'Info-blue',
  'instagram',
  'investment-memo',
  'investment_report',
  'kitchen',
  'landscape',
  'lavender_cross',
  'left-icon',
  'linkedin',
  'loan',
  'local_convenience_store',
  'local_mall',
  'location_automation',
  'location_city',
  'Position',
  'lock',
  'low_floor',
  'mail',
  'mastercard',
  'market-report',
  'market_report',
  'meeting_chart',
  'menu',
  'menu-alt-2',
  'messenger',
  'mid_floor',
  'minus',
  'more',
  'more-horizontal',
  'NewMortgage',
  "KnowledgeHub",
  'Golden Visa',
  'Blocks',
  'mortgage',
  'mortgage-check',
  'moving',
  'muted',
  'nature',
  'new_release',
  'night_shelter',
  'nx',
  'office',
  'other_houses',
  'outdoor_grill',
  'pause',
  'pdf',
  'pencil',
  'people',
  'person',
  'person_play',
  'pets',
  'phone',
  'phoneNew',
  'play-arrow-outline',
  'play',
  'plus',
  'plus-minus-morph',
  'plus_box',
  'pool',
  'preview',
  'properties',
  'property-brochure',
  'property_brochure',
  'prypco',
  'prypco_white',
  'prypco-about-col',
  'prypco-blocks',
  'prypco-w-logo-terms',
  'prypco-blocks-col',
  'prypco-blocks-dfsa',
  'prypco-blocks-regulated',
  'prypco-golden-visa',
  'prypco-b-logo',
  'prypco-w-logo',
  'prypco-hub',
  'prypco-hub-col',
  'prypco-manage',
  'prypco-mortgage',
  'prypco-mortgage-col',
  'prypco-o-cube',
  'prypco-rnpl',
  'prypco-rnpl-col',
  'prypco-services',
  'prypco-visa-services',
  'prypco-services-col',
  'prypco_agents',
  'quote',
  'quote_outlined',
  'receipt_long',
  'rectangle-grid',
  'recycle',
  'redo',
  'refresh',
  'request_page',
  'restaurant',
  'rnpl',
  'rnpl-mobile',
  'school',
  'search',
  'search-circle',
  'selector',
  'settings',
  'share',
  'sofa',
  'sort-asc',
  'sort-desc',
  'spa',
  'sports-gymnastics',
  'stacked_cubes',
  'stadium',
  'star',
  'star_half',
  'store',
  'subway',
  'success',
  'suite',
  'summarize',
  'swim',
  'telegram',
  'tiktok',
  'trash-can',
  'trash-can-outline',
  'triangle-downward',
  'tune',
  'tune_ff',
  'tune_bg_blue',
  'twitter',
  'union',
  'unmuted',
  'upload_cloud',
  'users',
  'valuation-report',
  'valuation_report',
  'villa',
  'wallet',
  'visa-services',
  'visa',
  'wardrobe',
  'warning',
  'warranty-badge-highlight',
  'whatsapp',
  'whatsappNew',
  'x',
  'flash',
  'wallet-latest',
  'building',
  'flash-new',
  'flash-active',
  'building-active',
  'wallet-active',
  'Token',
  'Token_checkout',
  'chevron-w-left',
  'star-04',
  'edit',
  'dining',
  'log-out-02',
  'pdf_view-eye',
  'new_arrow'
] as const;
